/// <amd-module name="Build/Admin/Common/Actions/AgentActions" />
import { Action } from "VSS/Reflux/Action";

import { TaskAgent, TaskAgentStatus } from "DistributedTask/Client/Contracts/TaskAgent";

export class AgentActions {
    public agentUpdated = new Action<TaskAgent>();
    public agentStatusUpdated = new Action<IAgentStatusPayload>();
}

export interface IAgentStatusPayload {
    agentId: number;
    status: TaskAgentStatus;
}
